module.exports = "/_next/static/images/c83d40c9a021303db05ec34bde71d2a8-nuconta-inclined-device@1x.png.webp";